<template>
<div>
  <b-card>
      <b-tabs pills card>
        <b-tab title="Reporte venta diaria por usuario" active>
        <b-row>    
            <b-col md="3">
            <br>
            <label for="Fecha">Fecha Inicial</label> 
            <b-input-group>
            <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="date" required v-model="fechaIniRVD"></b-form-input>
            </b-input-group>
            </b-col>
            <b-col md="3">
            <br>
            <label for="Fecha">Fecha Final</label> 
            <b-input-group>
            <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="date" required v-model="fechaFinRVD"></b-form-input>
            </b-input-group>
            </b-col>
             <b-col md="3"  v-if="mostrarTRVD" >
            <br>
                 <label for="Saldo">Valor Total</label>
                 <b-form-input v-model="this.total"  type="text"  placeholder="Total" disabled></b-form-input>
            </b-col>
            <b-col md="1">
                <br>
                <br>
                <b-button variant="success" @click="enviarRVD" >Generar</b-button>
            </b-col>
            <b-col md="1">
                <download-excel  v-if="mostrarTRVD"
                    class   = "btn btn-default"
                    :data   ="json_data"
                    :fields ="json_fieldsRVD"
                    name    = "reporteVentaDiariaPorusuario.xls">   
                    <br>                    
                    <b-button variant="link"><i class="fa fa-file-excel-o" aria-hidden="true"></i>Excel</b-button>
                </download-excel>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
              <br>
                <List :mapState="'cafeteriaReports'" :btneye="false" v-if="mostrarTRVD"  :showbtn="false" :allDispatch="'controlaccesoreportsaux'" :exportExcel="false" :excelHead="json_fieldsRVD" nameFileExcel="Este es un cataglo" ></List>
            </b-col>
        </b-row>
        </b-tab>
    </b-tabs>
  </b-card>
</div>
</template>
<script>
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import List from '@/components/modules/base/list.vue'
import {
    getCurrentDate,
    getDate
} from '@/api'

Vue.component('downloadExcel', JsonExcel)

export default {
 name: 'reportsCafeteriaList', 
 data (){
  return{
  fechaIniRVD:getCurrentDate(),
  fechaFinRVD:getCurrentDate(),
  fechaIniRVDP:'',
  fechaFinRVDP:'',
  fechaIniRM:'',
  fechaFinRM:'',
  idUser:'',
  IdRM:'',
  SaldoAc:'',
  nombreComRM:'',
  mostrarTRVD:false,
  mostrarTRVDP:false,
  mostrarTRM:false,
  List2:'',
  total:Number,
  total2:Number,
  json_fieldsRVD: {
            'Id Usuario': 'id',
            'Nombres': 'name',
            'Documento': 'num_doc',
            'fecha y hora': 'datetime',
            'Descripcion' :'products',
            'Valor' :'total',
        },
 json_fieldsRVDP: {
            'Categoría': 'nameC',
            'Subcategoría': 'nameS',
            'Producto': 'nameP',
            'Cantidad': 'CANTIDAD',
            'Subtotal' :'total',
            'Valor' :'total',
        },
 json_fieldsRM: {
            'Fecha y Hora': 'datetime',
            'Descripcion': 'products',
            'Valor': 'total',
        },
        json_data:'',
        json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
    }  
  
 },
 components: {
    List
  },
    methods:{
        consultar(){
            let  array={'id':this.idUser}
            this.$store.dispatch('cafeteriaReportsDataUser', array).then(Response=>{
                if( this.$store.getters.cafeteriaReports != null ){
                    this.IdRM= this.$store.getters.cafeteriaReports.id
                    this.nombreComRM= this.$store.getters.cafeteriaReports.name
                    this.SaldoAc= this.$store.getters.cafeteriaReports.saldo
                    
                }else{
                    alert("No Existe Usuario");
                }
                
            })  
         
        },
        enviarRVD(){
            this.mostrarTRVD = false
            let  array={'fechaIniRM':this.fechaIniRVD+' 00:00:00','fechafinRM':this.fechaFinRVD+' 23:59:00'}
            let mostrarTRVD= ''
            this.$store.dispatch('cafeteriaReportslistReversion', array).then(Response=>{
                if(this.$store.getters.cafeteriaReports.name != ''){
                    this.List= this.$store.getters.cafeteriaReports
                    this.json_data= this.$store.getters.cafeteriaReports.items
                    this.List2= this.$store.getters.cafeteriaReports.items
                    this.total = 0
                    this.List2.forEach(element => {
                        console.log('El valor total ',element.total)
                        this.total += Number(element.total)
                    });
                    console.log('Suma',this.total);
                    this.mostrarTRVD=true
                }else{
                    this.mostrarTRVD=false
                }
                
            })  
         
        },
        enviarRM(){
            this.mostrarTRM = false
            let  array={'IdRM':this.IdRM,'fechaIniRM':this.fechaIniRM+' 000:00:00','fechafinRM':this.fechaFinRM+' 23:59:00'}
            let mostrarTRM= ''
            this.$store.dispatch('cafeteriaReportslistRM', array).then(Response=>{
                if(this.$store.getters.controlaccesoreports.name != ''){
                    this.List= this.$store.getters.controlaccesoreports
                    this.json_data= this.$store.getters.cafeteriaReports.items
                    this.mostrarTRM=true
                }else{
                    this.mostrarTRM=false
                }
                
            })  
         
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/cafeteria/reversion/list.vue